// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error404_wrapper__2Ggn1","title":"Error404_title__1DON8","text":"Error404_text__1B0P9"};